<template>
    <div>
        <TextArea title="Descrição" field="description" :required="true" :maxLength="2000" v-model="description" />
        <Select title="Solicitado por" :showNewRegister="false" field="user" :url="urlUser" v-model="selectUser" />
        <div class="div-btn-save text-right">
            <Button _key="saveAuthorization" type="success" title="Salvar"
                :disabled="description == '' || selectUser.content == ''" classIcon="fas fa-save" size="medium"
                :clicked="save" />
        </div>
    </div>
</template>

<script>

import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";
import TextArea from "@nixweb/nixloc-ui/src/component/forms/TextArea";

import { mapActions, mapMutations } from "vuex";

export default {
    name: 'AuthorizationCreate',
    components: {
        Button, InputText, Select, TextArea
    },
    data() {
        return {
            urlUser: "/api/v1/adm/user/select-all",
            urlCreate: "/api/v1/adm/authorization/create",
            description: '',
            createdBy: '',
            selectUser: {},
        }
    },
    methods: {
        ...mapActions("generic", ["postApi"]),
        ...mapMutations("generic", ["addEvent", "hideModal", "removeLoading"]),
        save() {
            if (!this.description) return
            const obj = {
                description: this.description,
                createdBy: this.selectUser.content
            }
            let params = { url: this.urlCreate, obj: obj };
            this.postApi(params).then((response) => {
                if (response.success) {
                    this.description = ''
                    this.createdBy = ''
                }
                this.hideModal();
                this.removeLoading(["saveAuthorization"]);
                this.addEvent({ name: "getAllAuthorization" });
            });
        }
    }
}
</script>
<style scoped>
.div-btn-save {
    margin-top: 20px;
}
</style>